import loadable from '@loadable/component';
import { tw } from '@careinfo/tailwind';
import { useParams } from 'react-router-dom';
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import Spinner from '../../components/Reusable/Spinner';
import usePatchHook from '../../customHooks/usePatchHook';

const SettingComponent = loadable(() => import('../../components/Setting'));

const Setting = () => {
  const { slug } = useParams<{ slug: string }>();
  const { mutateAsync, isLoading: isPatchloading } = usePatchHook({
    queryKey: [`setting-${slug}`],
  });

  const { data, isLoading } = useGetHook({
    queryKey: [`setting-${slug}`],
    url: `${APIS.DELIVERY_PARTNER}${slug}/`,
    params: {},
  });

  const handleUpdate = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_PARTNER}${slug}/`;
    const formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleToggleActive = async (value: boolean, setError: any) => {
    const url = `${APIS.DELIVERY_PARTNER}${slug}/`;
    const formData = {
      is_active: value,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-4 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Setting</span>
      </div>
      <SettingComponent
        data={data}
        handleUpdate={handleUpdate}
        handleToggleActive={handleToggleActive}
        isLoading={isPatchloading}
      />
    </>
  );
};

export default Setting;
